import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { Topic } from "../../entities/topic";

@Injectable()
export class TopicRepo extends Repository<Topic>{
    constructor(private dataSource: DataSource) {
        super(Topic, dataSource.createEntityManager());
    }
    async getTopicsByChapter(chapter: number) {
        const topicData = this.createQueryBuilder('t')
            .select('t.id ,t.topic  ')
            .where(`t.chapter = '${chapter}'`)
        const data = await topicData.getRawMany();
        return data;
    }
}